@if(this.dataSource && this.dataSource.length > 0){
<div class="card margin-top">
    <table>

        <tr>
            @if(action){
            <th style="width: 55px;"></th>
            }

            @for(col of displayedColumns; track col) {
            <th [ngStyle]="{'width': col.width ? col.width : null }">{{col.title}}
            </th>
            }
        </tr>

        @for(item of dataSource; track item) {
        <tr>
            @if(action){
            <td class="action-emitter-button" (click)="actionEmitter(item)">
                <div><i class="fa-solid fa-ellipsis-vertical"></i></div>
            </td>
            }
            @for(col of displayedColumns; track col) {
            @if(col.key){
            <td>

                @if(col.template){
                <ng-container>
                    <ng-container
                        *ngTemplateOutlet="col.template; context: { $implicit: item[col.key], row: item }"></ng-container>
                </ng-container>
                }@else{
                {{ item[col.key] }}
                }
            </td>
            }
            }
        </tr>
        }
    </table>
    @if(pagination){
    <bt-paginator [pageNumber]="pageNumber" [pageSize]="pageSize" [totalNumber]="totalNumber"
        (clickPage)="clickPageEmitter($event)"></bt-paginator>
    }
</div>
}